import React from 'react';
import {
  Card, CardBody, Col, Spinner,
} from 'reactstrap';
import PropTypes from 'prop-types';

const LoadingCard = ({
  toggle,
}) => (
  <Col className="mb-10" xs={6} sm={4} md={4} lg={3} xl={2}>
    <Card className="pb-10">
      <CardBody className="fullCenter assetCard" onClick={toggle}>
        <div className="mt-10 card__title mb-0">
          <Spinner className="official" />
          <div className="mt-10 d-flex flex-row">
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <h5 className="ellipsis bold-text">Ajout en cours...</h5>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>
);

LoadingCard.propTypes = {
  toggle: PropTypes.func,
};

LoadingCard.defaultProps = {
  toggle: () => {},
};

export default LoadingCard;
